
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offline/enquiry",
      function () {
        return require("private-next-pages/offline/enquiry/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offline/enquiry"])
      });
    }
  